import { render } from "./Mapping.vue?vue&type=template&id=9c5f795e"
import script from "./Mapping.vue?vue&type=script&setup=true&lang=js"
export * from "./Mapping.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Pathways/Mapping.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c5f795e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c5f795e', __exports__)) {
    api.reload('9c5f795e', __exports__)
  }
  
  module.hot.accept("./Mapping.vue?vue&type=template&id=9c5f795e", () => {
    api.rerender('9c5f795e', render)
  })

}


export default __exports__